<template>
  <div class="">
    <el-container>
      <el-main>
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-input v-model.trim="inputCardNumber" placeholder="请输入卡号" />
          </el-form-item>
          <el-form-item>
            <el-select v-model="feedbackStatus" placeholder="请选择状态" style="width: 200px">
              <el-option :value=0 label="未回复"></el-option>
              <el-option :value=1 label="已回复"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" plain type="primary" icon="el-icon-search" @click="search(1)">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table @selection-change="selectIdChange" ref="feedbackTable" :data="feedbackTableData"
                  :row-style="{height:'40px'}" :call-style="{height: '5px,0',textAlign:'center'}"
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                    border style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="iccid" label="ICCID" width="200" align="center"></el-table-column>
          <el-table-column prop="feedback" label="意见建议" width="200" align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" width="180" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 0">未回复</div>
              <div v-if="scope.row.status === 1">已回复</div>
            </template>
          </el-table-column>
          <el-table-column prop="reply" label="回复" width="200" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="回复时间" width="180" align="center"></el-table-column>
          <el-table-column label="操作" min-width="200" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status===0" size="mini" @click="reply(scope.row)">回复</el-button>
              <el-button v-if="scope.row.status===1" size="mini" >/</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="search" v-bind:itemCount="8"></pagination>
        <el-dialog :visible.sync="showReply" :close-on-click-modal="false" title="内容回复" data-height="700">
          <el-form>
            <el-form-item>
              <el-input resize="none" type="textarea" :rows="3" style="height: 70px;width: 98%" placeholder="请输入回复内容" ref="replys" v-model="replys"></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showReply = false">取消</el-button>
            <el-button type="primary" @click="submitReply()">确定</el-button>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'feedback.vue',
  components: {
    Pagination
  },
  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
  },

  data() {
    return {
      replysInfo:{},
      inputCardNumber: '',
      feedbackStatus: '',
      address: '',
      feedbackTableData: [],
      showReply: false,
      replys: '',
      feedbackJs: require('../../../api/feedback')
    }
  },

  methods: {
    reply(info) {
      this.replysInfo.id=info.id
      this.showReply = true
    },

    search(page) {
      let data={
        current: page,
        size: this.$refs.pagination.size,
        iccid: this.inputCardNumber,
        status: this.feedbackStatus
      }
      this.feedbackJs.queryFeedbackList(data)
        .then(res => {
          if (res.data.code === '0') {
            this.feedbackTableData = res.data.data.rows
            this.$refs.pagination.render(page, res.data.data.total)
          } else {
            this.$alert(res.data.msg)
          }
        })
        .catch(err => {
          alert('异常了')
        })
    },
    submitReply() {
      this.replysInfo.replys=this.replys;
      this.feedbackJs.submitReplyInfo(this.replysInfo).then(res => {
        if (res.data.code === '0') {
          this.$alert(res.data.data)
          this.showReply = false
          this.search(1)
        } else {
          this.$alert(res.data.msg)
          this.showReply = false

        }
      })
    },
    selectIdChange(val) {
      let _this = this
      _this.multipleSelection = val
      let array = new Array()
      for (let i in _this.multipleSelection) {
        let section = _this.multipleSelection[i]
        let id = section.iccid
        array.push(id)
      }
      let str = array.join(',')
      _this.ids = str
    }
  }
}
</script>

<style scoped>
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
/deep/ ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 5px 0px 5px #f0f0f0;
  background: #d9d9d9;
}
/deep/ ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}
</style>
